export default __webpack_public_path__ + "static/media/icon-face-good-16x11.ceef62aa.svg";